<app-select-widgets-dropdown
  [id]="'select-widgets'"
  [options]="widgetOptions"
  [selected]="selectedOptions"
  (optionChange)="widgetOptionChange($event)"
></app-select-widgets-dropdown>
